import './about_post_card.css'
